document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.dark-mode-toggle');
  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var current = document.documentElement.getAttribute('data-theme');
      var next = current === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', next);
      localStorage.setItem('theme', next);
    });
  });
});